module.exports = __webpack_public_path__ + "static/media/icon-perfil.94e6c1ab.svg";